import './partner_widget.scss'
import '../../borrower_widget.scss'
import {BorrowerWidget} from "../../borrowerWidget";
import {Partner} from "../../../../../partner/model/Partner";

export class PartnerWidget {
    static instance = BorrowerWidget.wrapperInstanceFactory({
        controller: [PartnerWidget],
        template: require('./partner_widget.html')
    })

    private contact: Partner;

}